export default "__VITE_ASSET__DnNU8bSC__"